var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeigth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8571 13.784H0.142857C0.0642857 13.784 0 13.8483 0 13.9269V14.9983C0 15.0769 0.0642857 15.1412 0.142857 15.1412H11.8571C11.9357 15.1412 12 15.0769 12 14.9983V13.9269C12 13.8483 11.9357 13.784 11.8571 13.784ZM11.8571 0.855469H0.142857C0.0642857 0.855469 0 0.919754 0 0.998326V2.06975C0 2.14833 0.0642857 2.21261 0.142857 2.21261H11.8571C11.9357 2.21261 12 2.14833 12 2.06975V0.998326C12 0.919754 11.9357 0.855469 11.8571 0.855469ZM7.76429 5.60547C7.87143 5.60547 7.93214 5.48047 7.86607 5.39654L6.06607 3.11797C6.05416 3.10255 6.03887 3.09007 6.02138 3.08148C6.00389 3.07289 5.98466 3.06842 5.96518 3.06842C5.94569 3.06842 5.92647 3.07289 5.90898 3.08148C5.89149 3.09007 5.8762 3.10255 5.86429 3.11797L4.06429 5.39654C4.04929 5.4156 4.03997 5.43851 4.03739 5.46263C4.03481 5.48674 4.03907 5.5111 4.0497 5.53291C4.06032 5.55471 4.07687 5.57308 4.09745 5.58592C4.11803 5.59875 4.14182 5.60553 4.16607 5.60547H5.35714V10.3912H4.23571C4.12857 10.3912 4.06786 10.5162 4.13393 10.6001L5.93393 12.8769C5.98571 12.943 6.08571 12.943 6.13571 12.8769L7.93572 10.6001C8.00179 10.5162 7.94286 10.3912 7.83393 10.3912H6.64286V5.60547H7.76429Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeigth);
export default __webpack_public_path__ + "static/media/heigth.99abed5f14a8830920a219c0afd5d12b.svg";
export { ForwardRef as ReactComponent };